// This module simply returns a javascript object build from the JSON data
// in the page which holds the initialisation data for userMessaging

/* global _IMAGES_URL */

let rawData = {};
const dataLoaderElem = document.getElementById('user-messaging-data');
if (dataLoaderElem !== null) {
  // the data must be stored in the content attribute of a meta tag
  if (
    dataLoaderElem.tagName === 'META' &&
    dataLoaderElem.hasAttribute('content')
  ) {
    const encoded = dataLoaderElem.getAttribute('content');
    rawData = JSON.parse(atob(encoded));
  } else if (dataLoaderElem.textContent.trim() !== '') {
    rawData = JSON.parse(dataLoaderElem.textContent);
  }

  if (rawData.userMessaging) {
    rawData.userMessaging.emoticonURL = `${_IMAGES_URL}emoticons/`;
  }
}

export const data = rawData;
